import { createSlice } from '@reduxjs/toolkit';
import { setIsLoading } from '../isLoading.slice';
import axios from 'axios';
import { logOut } from '../../../resources/utils';


export const questionsSlice = createSlice({
    name: 'questions',
    initialState: {
        items: [],
        item: {},
        message: "",
        error: "",
    },
    reducers: {
        initialStateQuestion: (state, action) => {
            return {
                items: [],
                item: {},
                message: "",
                error: "",
            }
        },
        setQuestions: (state, action) => {
            return {
                items: action.payload,
                item: {},
                message: "",
                error: "",
            }
        },
        setQuestion: (state, action) => {
            return {
                items: [],
                item: action.payload,
                message: "",
                error: "",
            }
        },
        setQuestionMessages: (state, action) => {
            return {
                items: [],
                item: {},
                message: action.payload,
                error: "",
            }
        },
        setQuestionError: (state, action) => {
            return {
                items: [],
                item: {},
                message: "",
                error: action.payload,
            }
        },
    }
})

export const deleteQuestionThunk = (question_id) => dispatch => {
    dispatch(setIsLoading(true));
    axios.delete(`/forms/deleteQuestion/${question_id}`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setQuestionMessages(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setQuestionError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const deleteClausuleThunk = (question_id) => dispatch => {
    dispatch(setIsLoading(true));
    axios.delete(`/contracts/deleteClausule/${question_id}`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setQuestionMessages(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setQuestionError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};


export const { 
    initialStateQuestion,
    setQuestions,
    setQuestion,
    setQuestionMessages,
    setQuestionError
} = questionsSlice.actions;

export default questionsSlice.reducer;